import React, {Fragment} from "react";
import classNames from 'classnames';

import MatchAndEventMatchReportCard from "./MatchAndEventMatchReportCard";
import {Image} from "react-bootstrap";

import '../../../../assets/sass/pages/match-and-event-match-report/player-positions-card.scss';
import Divider from "../../../ui/Divider";
import PitchCanvas from "../../../ui/canvases/PitchCanvas";
import GoalMap from "../../../ui/canvases/GoalMap";

class PlayerPositions extends MatchAndEventMatchReportCard {
    /**
     * Renders the header of the card component.
     * @returns {React.ReactNode} The card header component.
     */
    renderHeader = () => "Player Positions";

    /**
     * Renders the body of the card component.
     * @returns {React.ReactNode} The card body component.
     */
    renderBody = () => {
        return (
            <Fragment>
                {this.renderTeamsPlan()}
                {this.renderTeamsPositions()}
            </Fragment>
        );
    };

    renderTeamsPlan = () => {
        const {team1, team2} = this.props;
        return <PlayerPositions.TeamsPlan team1={team1} team2={team2}/>;
    };

    renderTeamsPositions = () => {
        const {team1, team2} = this.props;
        return <PlayerPositions.TeamsPositions team1={team1} team2={team2}/>;
    };

    /**
     * Returns the classes of the card component.
     * @returns {string} The card classes.
     */
    cardClasses = () => classNames('match-and-event-match-report-card', 'player-positions-card');
}

PlayerPositions.TeamsPlan = props => {
    const {team1, team2} = props;
    const {logo: team1Logo, plan: team1Plan} = team1;
    const {logo: team2Logo, plan: team2Plan} = team2;

    const {formation: team1Formation} = team1Plan;
    const {formation: team2Formation} = team2Plan;

    return (
        <div className="teams-plan">
            <div className="team left">
                <Image className="team--logo" src={team1Logo}/>
                <div className="team--formation"> {team1Formation}</div>
            </div>
            <Divider show={true} direction="vertical"/>
            <div className="team right">
                <div className="team--formation"> {team2Formation}</div>
                <Image className="team--logo" src={team2Logo}/>
            </div>
        </div>
    )
};

PlayerPositions.TeamsPositions = props => {
    const {team1, team2} = props;

    const {plan: team1Plan} = team1;
    const {plan: team2Plan} = team2;

    const {playersPositions: team1PlayersPositions} = team1Plan;
    const {playersPositions: team2PlayersPositions} = team2Plan;

    const player1Color = "#F96274";
    const player2Color = "#2B82F7";
    const goalkeeperColor = "#212729";
    const textColor = "#FFFFFF";

    return (
        <div className="teams-positions">
            <div className="team left">
                <div className="team--position">
                    <GoalMap>
                        {team1PlayersPositions.map(item =>
                            <GoalMap.Node nodeType='player-position' x={item.x} y={item.y} radius={50} number={item.number} color={textColor} backgroundColor={item.goalkeeper ? goalkeeperColor : player1Color}/>)}
                    </GoalMap>
                </div>
            </div>
            <Divider show={true} direction="vertical"/>
            <div className="team right">
                <div className="team--position">
                    <GoalMap>
                        {team2PlayersPositions.map(item =>
                            <GoalMap.Node nodeType='player-position' x={item.x} y={item.y} radius={50} number={item.number} color={textColor} backgroundColor={item.goalkeeper ? goalkeeperColor : player2Color}/>)}
                    </GoalMap>
                </div>
            </div>
        </div>
    );
};

export default PlayerPositions;
